import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FontCase extends BaseOption {
  static myOptions = [
    { id: "standard", name: "Standard" },
    { id: "uppercase", name: "Uppercase" },
    { id: "lowercase", name: "Lowercase" },
    { id: "capitalize", name: "Capitalize" },
  ];

  static userInterfaceComponent = {
    label: "Font Case",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: this.myOptions,
    },
  };

  static defaultValue = "standard";
}
